import React from 'react';
import { NavLink } from 'react-router-dom';
import './CommunityLeftNav.css';

const navItems: Array<{ to: string; label: string; icon: string; exact?: boolean }> = [
  { to: '/app/community', label: '首页', icon: '🏠', exact: true },
  { to: '/app/community/topics', label: '话题广场', icon: '🏷️' },
  { to: '/app/community/saved', label: '收藏', icon: '📌' },
  { to: '/app/community/notifications', label: '消息', icon: '🔔' },
  { to: '/app/community/messages', label: '私信', icon: '✉️' },
  { to: '/app/community/profile', label: '我的主页', icon: '👤' },
  { to: '/app/community/settings', label: '设置', icon: '⚙️' },
];

const CommunityLeftNav: React.FC = () => {
  return (
    <nav className="community-shell__left-nav" aria-label="社区主导航">
      <div className="community-shell__logo">Herbal Circle</div>
      <ul>
        {navItems.map((item) => (
          <li key={item.to}>
            <NavLink
              end={item.exact}
              to={item.to}
              className={({ isActive }) =>
                `community-shell__left-link${isActive ? ' community-shell__left-link--active' : ''}`
              }
            >
              <span aria-hidden>{item.icon}</span>
              <span>{item.label}</span>
            </NavLink>
          </li>
        ))}
  </ul>
  <NavLink to="/app/community/compose" className="community-shell__left-compose">
        <span aria-hidden>✍️</span>
        <span>发帖</span>
      </NavLink>
    </nav>
  );
};

export default CommunityLeftNav;
